/**
 * Wraps a middleware processor function in a Redux middleware function.
 *
 * The returned middleware function takes the Redux middleware API, the next middleware function in the chain, and the current action, and passes them to the provided middleware processor function.
 *
 * @param fn The middleware processor function to wrap.
 * @returns A Redux middleware function that calls the provided middleware processor function.
 */ export const middleWareWrapper = (fn)=>{
    return (api)=>(next)=>(action)=>{
                return fn(api, next, action);
            };
};
